<template>
  <div class="learn-more--wrap">
    <v-container class="py-8 py-sm-15">
      <learn-more />
    </v-container>
  </div>
</template>

<script>
import LearnMore from '@/components/LearnMore.vue'

export default {
  name: 'partner-search-view',

  components: {
    LearnMore,
  },
}
</script>
